import UntrackedModel from "../../../common/models/untracked/untrackedModel";
import Organization from "../../../common/models/organization";
import Folder from "./folder";
import {DocumentType} from "../../../common/enums/documentType";
import {ICapable} from "../../../common/interfaces/capableInterfaces";
import Capable from "../../../common/mixins/capable";
import Shareable from "../../../common/mixins/shareable";
import {IOrganizationDocument} from "../../../common/interfaces/organizationDocumentInterfaces";
import {commonActions, RouteMap} from "../../../common/helpers/modelRouteHelper";

/**
 * @deprecated Migrating to use only TrackedModel
 * combining both versions of each document (e.g. there are 2 form.ts files)
 * ListView is first attempt at using TrackedModel in Document Management app
 */
export default class OrganizationDocument extends Shareable(Capable(UntrackedModel)) implements ICapable, IOrganizationDocument {
  title: string;
  author: any;
  parent: Folder;
  organization_id: string;
  folder_id: string;
  moving: boolean = false;
  except: string[] = ['moving', 'createEmbeddedObject'];
  collectionKey: string = null;
  rootName: string;
  _type: string;

  get organization(): Organization {
    if (this.parent instanceof Organization) {
      return this.parent;
    } else {
      return this.parent.organization;
    }
  }

  get isArchive(): boolean {
    return this.parent instanceof Folder && (this.parent.name === 'Archive' || this.parent.name === 'Trash');
  }

  get isForm(): boolean {
    return false;
  }

  get isLicense(): boolean {
    return false;
  }

  get isCertificate(): boolean {
    return false;
  }

  get isObjectModel(): boolean {
    return false;
  }

  canMoveTo(folder: Folder): boolean {
    return !folder.isArchiveFolder();
  }

  get classKey(): string {
    return 'document';
  }
}
